<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao
            :titulo="'Contratante'"
            :descricao="'Aqui é possível visualizar os dados dos contratantes validados com a RFB'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                1
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>

      <div
        :class="['mb-1', { 'desabilitar-inputs': !valueInner.carregado }]"
        style="position: relative;"
      >
        <div
          v-if="avisoTranferenciaMatriz()"
          class="aviso"
        >
          Atenção: em propostas de transferência de Matriz deve haver obrigatoriamente um CNPJ de Matriz informado!
        </div>
        <div
          v-if="avisoCnpjNaoFilial()"
          class="aviso"
        >
          Atenção: esse CNPJ não pertence a filial!
        </div>
        <div
          v-for="(empresa, $index) in valueInner.empresas"
          :key="$index"
        >
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <b-form-group label="CNPJ">
                    <b-input-group>
                      <inscricao-federal
                        :value="empresa.inscricao"
                        :tipo-inscricao="'cnpj'"
                        :disabled="true"
                      />
                      <b-input-group-append>
                        <b-button
                          v-b-tooltip.hover
                          title="Busca dados da RFB"
                          :variant="empresa.erroNavegacao ? 'danger' : 'primary'"
                          style="float:right"
                          :disabled="!empresa.erroNavegacao"
                          @click="buscarDados(empresa.inscricao)"
                        >
                          <feather-icon
                            v-if="!empresa.erroNavegacao"
                            icon="CheckIcon"
                          />
                          <feather-icon
                            v-if="empresa.erroNavegacao"
                            icon="RotateCwIcon"
                          />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Razão Social">
                    <b-form-input
                      v-model="empresa.nomeEmpresarial"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Tipo">
                    <b-form-input
                      v-model="empresa.matrizFilial"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <small
                v-if="empresa.erroNavegacao"
                class="text-danger"
              >Não foi possível concluir a busca de dados na RFB,
                verifique o CNPJ informado e tente novamente!</small>
            </b-col></b-row>
        </div>
        <div
          v-if="!valueInner.realizadoBusca"
          id="loader-wrapper"
        >
          <div id="loader" />
        </div>
      </div>
      <b-row class="mb-50">
        <b-col>
          <divisoria-descricao
            :titulo="'Sócios'"
            :descricao="'Aqui você pode adicionar os sócios com suas informações detalhadas'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                2
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>

      <b-row v-if="filial">
        <b-col cols="12">
          <b-form-group>
            <b-row>
              <b-col cols="4">
                <b-input-group>
                  <inscricao-federal
                    v-model="valueInner.inscricaoCNPJMatriz"
                    :tipo-inscricao="'cnpj'"
                    :disabled="valueInner.enviadoParaAnalise"
                  />
                  <b-input-group-append>
                    <b-button
                      v-b-tooltip.hover
                      title="Busca dados da RFB"
                      :variant="valueInner.erroNavegacaoMatriz ? 'danger' : 'primary'"
                      style="float:right"
                      :disabled="!validarRaizCNPJ || (valueInner.enviadoParaAnalise)"
                      @click="buscarSocios(valueInner.inscricaoCNPJMatriz)"
                    >
                      <feather-icon
                        v-if="!buscaSocios"
                        icon="SearchIcon"
                      />
                      <feather-icon
                        v-if="!valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="CheckIcon"
                      />
                      <feather-icon
                        v-if="valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="RotateCwIcon"
                      />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <div>
                <i>
                  <font-awesome-icon :icon="faQuestionCircle" />
                  Informe o CNPJ da Matriz para que o sistema realize a importação dos sócios
                </i>
              </div>
            </b-row>
          </b-form-group>
          <small
            v-if="valueInner.erroNavegacaoMatriz"
            class="text-danger"
          >
            Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!
          </small>
          <small
            v-if="valueInner.socios.some(som => som.veioDoHub) && validarRaizCNPJ"
            class="text-success"
          >Busca de
            dados
            importada do Honorarium</small>
          <small
            v-else-if="valueInner.socios.some(som => som.veioDoRFB) && validarRaizCNPJ"
            class="text-success"
          >
            Busca de dados importada da RFB!</small>
          <small
            v-if="!validarRaizCNPJ"
            class="text-danger"
          >Validação de raiz: 8 primeiros dígitos devem ser
            iguais</small>
        </b-col>
      </b-row>

      <div
        :class="['mb-1', { 'carregando-dados': !valueInner.carregado }]"
        style="position: relative;"
      >
        <div
          v-for="(socio, $index) in valueInner.socios"
          :key="$index"
        >
          <socio-empresa
            :ref="`socio${socio.code}`"
            :socio="socio"
            :desabilitar-nome="(filial && !valueInner.primeiraBuscaMatriz) || (valueInner.enviadoParaAnalise) || (socio.veioDoHub) || (socio.veioDoRFB)"
            :externo="true"
            :disabled="(filial && !valueInner.primeiraBuscaMatriz) || (socio.veioDoHub) || (valueInner.enviadoParaAnalise)"
            :enviado-analise="valueInner.enviadoParaAnalise"
            :desabilita-anexo="valueInner.enviadoParaAnalise"
            :lista-emails="valueInner.socios"
            @adicionar-item="adicionarItem($event)"
            @remover-item="removerItem($index)"
            @verificar-responsavel="verificarRFB($event)"
          />
        </div>

      </div>
      <certificado-e-anexo
        ref="anexos"
        v-model="valueInner.anexosECertificado"
        :pre-geracao-id="valueInner.id"
        :desabilitar-campos="valueInner.enviadoParaAnalise"
        :filial="filial"
      />
      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao
            :titulo="'Outras informações'"
            :descricao="'Informe a data de início da Responsabilidade Técnica e o e-mail para recebimento dos boletos e NFs'"
          >
            <template slot="complemento-numero">
              <div class="circle">
                5
              </div>
            </template>
          </divisoria-descricao>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <div style="display: flex">
            <div>
              <legend style="font-size: 14px;">
                Data de início</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Aqui deve ser informado a data de início, essa data é o início da Responsabilidade Técnica."
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon :icon="faQuestionCircle" />
              </i>
            </div>
          </div>
          <validation-provider
            #default="{ errors }"
            rules="required"
            :name="'Data de início'"
          >
            <data-input
              v-model="valueInner.dataInicio"
              :disabled="valueInner.enviadoParaAnalise"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
          <loading
            :is-loading="isLoading || !valueInner.realizadoBusca"
            :cancelar-upload="cancelarBusca"
            :show-message="'Prezado, estamos buscando os dados. Aguarde!'"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12">
          <email-input
            :value="valueInner.emailsBoletosNFs"
            :require="true"
            :disabled="valueInner.enviadoParaAnalise"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="!filial && valueInner.empresas && valueInner.empresas.length > 1"
        class="mt-1"
      >
        <b-col>
          <b-form-group label="De que forma deve ser faturado e enviado os boletos?">
            <validation-provider
              #default="{ errors }"
              rules="required"
              :name="'Forma de faturamento'"
            >
              <b-select
                v-model="valueInner.eTipoFaturamentoBoletos"
                :options="[{ value: 1, text: 'Separado por CNPJ' }, { value: 2, text: 'Consolidado na Matriz' }]"
                :disabled="valueInner.enviadoParaAnalise"
              />
              <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-form-group
          label="Descrição (opcional)"
          class="col-12"
        >
          <b-textarea
            v-model="valueInner.descricao"
            :disabled="valueInner.enviadoParaAnalise"
          />
        </b-form-group>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.circle {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #5e5873;
  border-radius: 50%;
  text-align: center;
  color: #5e5873;
  display: inline-block;
}

.desabilitar-inputs {
  pointer-events: none;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(0deg);
    /* IE 9 */
    transform: rotate(0deg);
    /* Firefox 16+, IE 10+, Opera */
  }

  100% {
    -webkit-transform: rotate(360deg);
    /* Chrome, Opera 15+, Safari 3.1+ */
    -ms-transform: rotate(360deg);
    /* IE 9 */
    transform: rotate(360deg);
    /* Firefox 16+, IE 10+, Opera */
  }
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { generateCode } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import { getUserInfo } from '@/auth/utils'

export default {
  name: 'TransferenciaMatrizEFilial',
  components: {
    ValidationProvider,
    FontAwesomeIcon,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    CertificadoEAnexo: () => import('../certificado-e-anexos/CertificadoEAnexos.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    SocioEmpresa: () => import('@/shared/components/socio-empresa-contrato/SocioEmpresaContrato.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    InscricaoFederal: () => import('@/shared/components/inscricao-federal/InscricaoFederal.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    filial: {
      type: Boolean,
      default: false,
    },
    tipoProposta: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      buscaSocios: false,
      faQuestionCircle,
      isLoading: false,
      valueInner: {
        emailsBoletosNFs: [],
        enviadoParaAnalise: false,
        realizadoBusca: true,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          inscricao: null,
          tipoInscricao: 'cpf',
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
        inscricaoCNPJMatriz: null,
        erroNavegacaoMatriz: false,
        primeiraBuscaMatriz: false,
      },
      invalidTags: [],
      duplicateTags: [],
    }
  },
  computed: {
    validarRaizCNPJ() {
      let valido = true
      if (this.valueInner.empresas && this.valueInner.inscricaoCNPJMatriz) {
        const raiz = this.valueInner.inscricaoCNPJMatriz.replace('.', '').substring(0, 8)
        this.valueInner.empresas.forEach(each => {
          const raizFilial = each.inscricao.replace('.', '').substring(0, 8)
          if (raiz !== raizFilial) {
            valido = false
          }
        })
      }
      return valido
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        if (!this.valueInner.id || this.valueInner.id === 0) {
          this.valueInner.emailsBoletosNFs.push(getUserInfo().email)
        }
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (!this.valueInner.id || this.valueInner.id === 0) {
      this.valueInner.emailsBoletosNFs.push(getUserInfo().email)
    }
  },
  methods: {
    adicionarEmail(value) {
      this.valueInner.emailsBoletosNFs = value
    },
    adicionarItem() {
      if (!this.valueInner.enviadoParaAnalise) {
        const item = {
          veioDoRFB: false,
          veioDoHub: false,
          inscricao: null,
          tipoInscricao: 'cpf',
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          code: generateCode(),
        }
        this.valueInner.socios.push(item)
      }
    },
    removerItem(index) {
      if (!this.valueInner.enviadoParaAnalise) {
        this.valueInner.socios.splice(index, 1)

        if (this.valueInner.socios.length === 0) {
          this.adicionarItem()
        }
      }
    },
    buscarDados(inscricao) {
      // eslint-disable-next-line global-require
      const axios = require('axios')
      this.isLoading = true
      api.getEmpresasPreGeracao([inscricao], axios.CancelToken)
        .then(payload => {
          const dados = payload.data
          // eslint-disable-next-line no-unused-vars
          this.valueInner.empresas = this.valueInner.empresas.filter(fin => fin.inscricao !== inscricao)
          this.valueInner.empresas.push(dados.empresas.find(fin => fin.inscricao === inscricao))
          this.valueInner.empresas = this.valueInner.empresas.sort().reverse()
          this.isLoading = false
          if (dados.socios && dados.socios.length > 0) {
            if (this.valueInner.socios.length > 0) {
              dados.socios.forEach(socio => {
                this.valueInner.socios.push(socio)
              })
              if (this.valueInner.socios.length !== 1) {
                this.valueInner.socios = this.valueInner.socios.filter(filter => filter.nome === '' || filter.nome !== null)
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (dados.empresas.find(fin => fin.inscricao === inscricao).matrizFilial === 'Matriz') {
                this.valueInner.socios = dados.socios
              }
            }
          }
        }).catch(err => {
          this.isLoading = false
          throw err
        })
    },
    buscarSocios(inscricao) {
      this.buscaSocios = true
      this.isLoading = true
      // eslint-disable-next-line global-require
      const axios = require('axios')
      if (inscricao !== '') {
        this.valueInner.primeiraBuscaMatriz = true
        api.getSociosMatriz({ cadastroFederal: inscricao, constituicao: false }, axios.CancelToken)
          .then(payload => {
            const dados = payload.data
            this.valueInner.erroNavegacaoMatriz = (dados.empresas && dados.empresas.length > 0 && dados.empresas.some(some => some.matrizFilial === 'Filial' || !some.matrizFilial))
            this.isLoading = false
            this.valueInner.socios = this.valueInner.socios.filter(filt => !filt.veioDoRFB && !filt.veioDoHub)
            if (dados.socios && dados.socios.length > 0) {
              if (this.valueInner.socios.length > 0) {
                dados.socios.forEach(socio => {
                  this.valueInner.socios.push(socio)
                })
                if (this.valueInner.socios !== 1) {
                  this.valueInner.socios = this.valueInner.socios.filter(filter => filter.nome === '' || filter.nome !== null)
                }
              } else {
                this.valueInner.socios = dados.socios
              }
            }
          }).catch(err => {
            this.isLoading = false
            throw err
          })
      }
    },
    avisoTranferenciaMatriz() {
      return this.valueInner.realizadoBusca && this.tipoProposta === 'transferencia' && !this.filial && !this.valueInner.empresas.some(som => som.matrizFilial === 'Matriz')
    },
    avisoCnpjNaoFilial() {
      return this.valueInner.realizadoBusca && this.tipoProposta === 'transferencia' && this.filial && this.valueInner.empresas.some(filial => filial.matrizFilial === 'Matriz')
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    verificarRFB(value) {
      const responsavel = this.valueInner.socios.find(find => find !== value.socio && find.responsavelRFB)
      if (responsavel) {
        responsavel.responsavelRFB = false
      }
    },
    cancelarBusca() {
      this.$emit('closeInCancel')
      this.isLoading = false
      this.valueInner.realizadoBusca = true
      api.cancelarBusca()
    },
    retornaTodosArquivos() {
      const arquivos = []
      for (let index = 0; index < this.valueInner.socios.length; index += 1) {
        const { code } = this.valueInner.socios[index]
        const arquivo = this.$refs[`socio${code}`][0].$refs[`upload${code}`].value[0]
        if (arquivo) {
          arquivos.push({
            file: arquivo.file,
            nome: `${code};${arquivo.filename || arquivo.name}`,
          })
        }
      }
      return arquivos
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.valueInner.emailsBoletosNFs = emails
    },
  },
}
</script>
